import React from 'react';
import { Select, Typography, ConfigProvider } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import { useBranch, BRANCH_OPTIONS } from './BranchContext';

const { Text } = Typography;

const ALL = BRANCH_OPTIONS.map((b) => b.value);

const BranchFilter = () => {
  const { branches, setBranches } = useBranch();

  const handleChange = (val) => {
    if (!val || val.length === 0) {
      setBranches(ALL);
    } else {
      setBranches(val);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <BankOutlined style={{ color: '#8895a7', fontSize: 14 }} />
      <Text style={{ color: '#8895a7', fontSize: 13 }}>Branch</Text>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionSelectedBg: 'transparent',
              optionActiveBg: 'transparent',
              optionSelectedColor: '#1A3C7A',
              optionSelectedFontWeight: 600,
              controlOutline: 'transparent',
              controlOutlineWidth: 0,
            },
          },
        }}
      >
        <Select
          mode="multiple"
          value={branches}
          onChange={handleChange}
          options={BRANCH_OPTIONS}
          style={{ width: 200 }}
          size="small"
          maxTagCount="responsive"
          allowClear={false}
          showSearch={false}
          suffixIcon={null}
        />
      </ConfigProvider>
    </div>
  );
};

export default BranchFilter;
